// @ts-nocheck

import React, { useEffect, useState, useRef } from 'react';
import { Background, Container, AddLeft, SectionMid, AddRight, BodySection, HeaderSection, AddBelow, Title, KeyboardImage } from './styles'

// images
import keyboard from '../assets/images/mech.png'

// sounds blue switch
import bls1 from '../assets/audio/bls1.mp3'
import bls2 from '../assets/audio/bls2.mp3'
import bls3 from '../assets/audio/bls3.mp3'
import bls4 from '../assets/audio/bls4.mp3'
import bls5 from '../assets/audio/bls5.mp3'
import blsspacebar from '../assets/audio/bls1.mp3'

// sounds red switch
import rs1 from '../assets/audio/rs1.mp3'
import rs2 from '../assets/audio/rs2.mp3'
import rs3 from '../assets/audio/rs3.mp3'
import rs4 from '../assets/audio/rs4.mp3'
import rs5 from '../assets/audio/rs5.mp3'
import rsspacebar from '../assets/audio/rsspacebar.mp3'

// sounds brown switch
import brs1 from '../assets/audio/brs1.mp3'
import brs2 from '../assets/audio/brs2.mp3'
import brs3 from '../assets/audio/brs3.mp3'
import brs4 from '../assets/audio/brs4.mp3'
import brs5 from '../assets/audio/brs5.mp3'
import brsspacebar from '../assets/audio/brsspacebar.mp3'

import { Howl } from 'howler';
import { Dropdown } from 'react-bootstrap';

const keys = {
  bls: [bls1, bls2, bls3, bls4, bls5],
  rds: [rs1, rs2, rs3, rs4, rs5, rsspacebar],
  brs: [brs1, brs2, brs3, brs4, brs5, brsspacebar],
};

function randomKey(min = 0, max = 4) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function App() {
  const selectedItemRef = useRef('bls');
  const [selectedItem, setSelectedItem] = useState(selectedItemRef.current);

  // volume state (0.0 - 1.0) e ref para usar no listener sem recriar o handler
  const [volume, setVolume] = useState(0.5);
  const volumeRef = useRef(volume);

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = Math.max(0, Math.min(1, Number(e.target.value) / 100));
    setVolume(v);
    volumeRef.current = v;
  };

  // ref para inserir o script dentro do AddLeft sem quebrar o JSX
  const addLeftRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = addLeftRef.current;
    if (!container) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9425071194707938';
    script.crossOrigin = 'anonymous';

    container.appendChild(script);

    return () => {
      if (container.contains(script)) container.removeChild(script);
    };
  }, []);

  const handleSelect = (eventKey) => {
    selectedItemRef.current = eventKey;
    setSelectedItem(eventKey);
  };

  useEffect(() => {
    function handleKeyDown(e) {
      const selectedItem = selectedItemRef.current;
      let audioSrc = keys[selectedItem][randomKey()];

      if (e.key === ' ' && selectedItem === 'bls') {
        audioSrc = blsspacebar;
        console.log('blue switch')
      } else if (e.key === ' ' && selectedItem === 'rds') {
        audioSrc = rsspacebar;
        console.log('red switch')

      } else if (e.key === ' ' && selectedItem === 'brs') {
        audioSrc = brsspacebar;
        console.log('brown switch')

      }

      console.log(selectedItem);
      // aplica volume atual
      var sound = new Howl({
        src: [audioSrc],
        volume: volumeRef.current
      });

      sound.play();
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  return (

    <Container className="App">
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
        integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
        crossOrigin="anonymous"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Dosis:wght@300&display=swap" rel="stylesheet" />
      <Background>

        <HeaderSection>
          <Title>The Mech</Title>

          <Dropdown onSelect={handleSelect}>
            <Dropdown.Toggle 
              size="lg" 
              id="dropdown-button-dark-example1" 
              variant="dark"
              style={{
                backgroundColor: '#373A3E',
              }}
            >
              Select Switch Color
            </Dropdown.Toggle>

            <Dropdown.Menu 
              variant="dark"
              className="dropdown-menu-gradient"
            >
              <Dropdown.Item eventKey="bls" active={selectedItem === 'bls'}>
                Blue
              </Dropdown.Item>
              <Dropdown.Item eventKey="rds" active={selectedItem === 'rds'}>Red</Dropdown.Item>
              <Dropdown.Item eventKey="brs" active={selectedItem === 'brs'}>Brown</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* controle de volume (0 a 100) */}
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <label style={{ color: '#373A3E', fontSize: 14 }}>Volume</label>
            <input
              type="range"
              min={0}
              max={100}
              value={Math.round(volume * 100)}
              onChange={handleVolumeChange}
              aria-label="Volume"
            />
            <span style={{ color: '#373A3E', fontSize: 12 }}>{Math.round(volume * 100)}%</span>
          </div>
        </HeaderSection>
        <BodySection autofocus>
          <AddLeft>
            {/* container onde o script será injetado */}
            <div ref={addLeftRef} />
            {/* <h2>PROPAGANDA AQUI</h2> */}
          </AddLeft>
          <SectionMid>
            <KeyboardImage src={keyboard} alt="keyboard" />
          </SectionMid>
          <AddRight>

            {/* { <h2>PROPAGANDA AQUI</h2> } */}

          </AddRight>

        </BodySection>
        <AddBelow>
          {/* { <h2>PROPAGANDA AQUI</h2> } */}
        </AddBelow>
      </Background>
    </Container>
  );
}

export default App;
